import { gsap } from 'gsap/all';
class BrowserVars {
  constructor(element) {
    this.element = element;
    this.updateDimensions();
    this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.lastTime = Date.now();
    this.maxVelocity = 15; // Adjust based on desired sensitivity
    this.connect();
  }

  connect() {
    document.body.addEventListener('mousemove', this.throttleMouseMove.bind(this), { passive: true });
    // window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
    // this.handleScroll();
  }

  updateDimensions() {
    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;
  }

  handleResize() {
    requestAnimationFrame(() => this.updateDimensions());
  }

  throttleMouseMove(event) {
    requestAnimationFrame(() => this.mouseMove(event));
  }

  mouseMove(evt) {
    const root = document.documentElement;
    root.style.setProperty('--mouse-x', `${evt.clientX}`);
    root.style.setProperty('--mouse-y', `${evt.clientY}`);
    root.style.setProperty('--mouse-x-percent', `${((evt.clientX / this.windowWidth) - 0.5) * 2}`);
    root.style.setProperty('--mouse-y-percent', `${((evt.clientY / this.windowHeight) - 0.5) * 2}`);
    
    // root.style.setProperty('--mouse-y-percent', `${((evt.clientY / this.windowHeight) - 0.5) * 2}`);
    const percentage = evt.clientX / this.windowWidth;
    const mapPercentage = percentage < 0 ? 0 : percentage > 1 ? 1 : percentage;
    const currentItem = Math.floor(5 * mapPercentage);
    root.style.setProperty('--current-item', currentItem);
  }

  handleScroll() {
    requestAnimationFrame(() => {
      this.scrollVelocity();
      this.pageScroll();
    });
  }

  scrollVelocity() {
    const now = Date.now();
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const deltaTime = now - this.lastTime;
    const deltaScroll = currentScrollTop - this.lastScrollTop;
    let velocity = deltaScroll / deltaTime;
    velocity = this.mapVelocityToRange(velocity);
  
    // Smoothly update the scroll velocity variable
    this.updateScrollVelocityVariable(velocity);
  
    this.lastScrollTop = currentScrollTop;
    this.lastTime = now;
  
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = setTimeout(() => {
      // Smoothly transition to 0 when user stops scrolling
      gsap.to(this, {
        duration: 0, // Adjust for smoother or quicker transition
        velocity: 0,
        onUpdate: () => this.updateScrollVelocityVariable(this.velocity),
      });
    }, 50); // Adjust delay as needed
  }

  mapVelocityToRange(velocity) {
    return Math.max(-1, Math.min(1, velocity / this.maxVelocity));
  }

  updateScrollVelocityVariable(velocity) {
    // Assuming `this.velocity` is used to keep track of the current velocity for GSAP's onUpdate
    this.velocity = velocity;
    // Use GSAP to update the CSS variable smoothly
    gsap.to(document.documentElement, {
      '--scroll-velocity': velocity,
      duration: 0.1, // Short duration for a smooth transition, adjust as needed
      ease: 'none', // Use a linear ease for consistent speed
      overwrite: true, // Overwrites previous animations of the same property
    });
  }
  

  pageScroll() {
    document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}`);
  }
}

export default BrowserVars;
